export default __webpack_public_path__ + "static/media/Watcher of the Den.e3c2228c.jpg";